// extracted by mini-css-extract-plugin
module.exports = {"riskLabelTag":"RiskLabelTag_riskLabelTag__QC7_U","noFill":"RiskLabelTag_noFill__Tq12_"};